var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a-page-header",
        { staticClass: "page-header flex-center", on: { back: _vm.back } },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: { click: _vm.back },
              slot: "title",
            },
            [_vm._v("返回 百日誓师")]
          ),
          _c(
            "div",
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.createCourse } },
                [_vm._v("创建")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("a-table", {
        attrs: {
          rowKey: _vm.rowKey,
          columns: _vm.columns,
          "data-source": _vm.dataSource,
          expandedRowKeys: _vm.expandedRowKeys,
          showHeader: false,
          pagination: _vm.ipagination,
          loading: _vm.loading,
        },
        on: {
          change: _vm.handleTableChange,
          expandedRowsChange: _vm.expandedRowsChange,
        },
        scopedSlots: _vm._u([
          {
            key: "operation",
            fn: function (text, record) {
              return _c(
                "div",
                { staticClass: "action-detail" },
                [
                  _c(
                    "a-dropdown",
                    {
                      attrs: {
                        placement: "bottomCenter",
                        overlayStyle: { width: "80px" },
                      },
                    },
                    [
                      _vm.userInfo().username === "admin"
                        ? _c("span", [_vm._v("添加")])
                        : _vm._e(),
                      _c(
                        "a-menu",
                        { attrs: { slot: "overlay" }, slot: "overlay" },
                        _vm._l(_vm.dropdownList, function (item) {
                          return _c("a-menu-item", { key: item.key }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  "text-align": "center",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addResources(item, record)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.userInfo().username === "admin"
                    ? _c("a-divider", {
                        staticStyle: { margin: "0 15px" },
                        attrs: { type: "vertical" },
                      })
                    : _vm._e(),
                  _vm.userInfo().username === "admin"
                    ? _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.editRecord(record)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                  _vm.userInfo().username === "admin"
                    ? _c("a-divider", {
                        staticStyle: { margin: "0 15px" },
                        attrs: { type: "vertical" },
                      })
                    : _vm._e(),
                  _c(
                    "a-popconfirm",
                    {
                      attrs: {
                        title: "确定要删除该记录吗？",
                        "ok-text": "是",
                        "cancel-text": "否",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.deleteRecord(record)
                        },
                        cancel: () => {},
                      },
                    },
                    [
                      _vm.userInfo().username === "admin"
                        ? _c("span", { style: { color: "#f81d22" } }, [
                            _vm._v("删除"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            },
          },
          {
            key: "expandedRowRender",
            fn: function (record) {
              return _c("a-table", {
                attrs: {
                  "data-source": record.ceremonyItemContentList,
                  columns: _vm.innerColumns,
                  pagination: false,
                  showHeader: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "operation",
                    fn: function (text, record) {
                      return _c(
                        "div",
                        { staticClass: "action-detail" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editResources(record)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm.userInfo().username === "admin"
                            ? _c("a-divider", {
                                staticStyle: { margin: "0 15px" },
                                attrs: { type: "vertical" },
                              })
                            : _vm._e(),
                          _c(
                            "a-popconfirm",
                            {
                              attrs: {
                                title: "确定要删除该记录吗？",
                                "ok-text": "是",
                                "cancel-text": "否",
                              },
                              on: {
                                confirm: function ($event) {
                                  return _vm.deleteResources(record)
                                },
                                cancel: () => {},
                              },
                            },
                            [
                              _vm.userInfo().username === "admin"
                                ? _c("span", { style: { color: "#f81d22" } }, [
                                    _vm._v("删除"),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    },
                  },
                ]),
              })
            },
          },
        ]),
      }),
      _c("CreateCourseOath", {
        ref: "createCourseOathRef",
        attrs: { recordData: _vm.recordData },
        on: { refreshData: _vm.loadData },
      }),
      _c(_vm.comInfo.component, {
        ref: "modalRef",
        tag: "component",
        attrs: { recordData: _vm.recordData },
        on: { refreshData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }